import React from 'react';

const FeedbacksHeader = () => {
    return (
        <div>
            <h1>Feedbacks</h1>
        </div>
    );
};

export default FeedbacksHeader;
